import React from "react";
import { useNavigate } from "react-router-dom";
import { LegalLayout, Section } from "@/components/LegalLayout";
import { Button } from "@/components/ui/button";
import { Flag } from "lucide-react";

const PROHIBITED = [
  "Harassment", "Threats", "Hate or discriminatory abuse", "Scams", "Fraudulent opportunities",
  "Fake creator or business identities", "Deliberately falsified metrics", "Spam", "Illegal content",
  "Infringing content", "Sexual exploitation", "Attempts to misuse personal information", "Other unlawful use of the service",
];

export default function CommunityGuidelines() {
  const navigate = useNavigate();
  return (
    <LegalLayout metaTitle="Community Guidelines — Nearfluence" metaDescription="The behaviour Nearfluence expects and prohibits to keep the community safe and trusted." title="Community Guidelines" subtitle="Nearfluence only works when it's a safe, honest place for creators and businesses.">
      <Section title="What we don't allow">
        <p>To protect the community, the following are prohibited on Nearfluence:</p>
        <div className="mt-3 flex flex-wrap gap-2">
          {PROHIBITED.map((p) => <span key={p} className="rounded-full border border-rose-200 bg-rose-50 px-3 py-1 text-sm font-medium text-rose-700">{p}</span>)}
        </div>
      </Section>
      <Section title="How we enforce this">
        <p>Nearfluence may investigate reports and may restrict, suspend or remove accounts, content or opportunities where appropriate. We aim to be fair, but keeping the community safe comes first.</p>
      </Section>
      <Section title="Report a concern">
        <p>If you see something that breaks these guidelines, please tell us.</p>
        <div className="mt-3"><Button data-testid="report-concern-btn" onClick={() => navigate("/contact?category=Report%20a%20user")} className="rounded-full bg-emerald-600 hover:bg-emerald-700"><Flag className="mr-2 h-4 w-4" /> Report a concern</Button></div>
      </Section>
    </LegalLayout>
  );
}
